import * as yup from "yup";

import { ERRORS_MESSAGE } from "@bms/constants";

export const validation = () => {
  return yup.object().shape({
    method: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
    category: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
  });
};
